import { render, staticRenderFns } from "./ScheduledPostsPage.vue?vue&type=template&id=5e2046c7&"
import script from "./ScheduledPostsPage.vue?vue&type=script&lang=js&"
export * from "./ScheduledPostsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports